import React, { useEffect, useState } from 'react';
import { Container } from 'typescript-ioc';
import { injectIntl, IntlShape } from 'react-intl';
import classNames from 'classnames';
import { Link } from '../../../../../infrastructure/components/router-extensions';
import { isPathIncludesInCurrentRoute } from '../../../../../infrastructure/utils/common.utils';
import './navigation-bar.scss';
import { getMainNavigationLinks, INavigationLink } from '../../../../../constants/navigation.constants';
import { IRouter } from '../../../../../infrastructure/router';
import { getEventRoutes } from '../../../../../infrastructure/utils/route.utils';
import { EventDetailsContext } from '../../../../global.context';
import NavigationBarClock from './navigation-bar-clock';


interface IProps {
    intl: IntlShape;
    links?: INavigationLink[];
}

const NavigationBar = injectIntl((props: IProps) => {
    const routingService = Container.get(IRouter);
    const route = routingService.router.getState();
    const eventId = route.params.eventId;
    const [accountId, setAccountId] = useState(route.params.accountId);

    useEffect(() => {
        setAccountId(route.params.accountId);
    });

    useEffect(() => {
        const eventRoutesSubscription = routingService.listenAll(getEventRoutes(), (params: { accountId: string }) => {
            setAccountId(parseInt(params.accountId, 10));
        });
        return () => {
            eventRoutesSubscription();
        };
    }, []);

 	const currentLinks = props.links || getMainNavigationLinks(accountId, props.intl);

    return (
        <div className='navigation-bar'>
            <nav className='navigation-bar__links'>
                <ul>
                    {currentLinks.filter(el => !el.isHidden).map(({label, routeEnum, routeParams, routePath}) => {
                        const routeClass = classNames(
                            {'navigation-bar__link-wrapper--selected': isPathIncludesInCurrentRoute(routePath || routeEnum, route)}
                        );

                        return (
                            <li key={label} className='navigation-bar__link-wrapper'>
                                <Link
                                    routeEnum={routeEnum}
                                    routeParams={routeParams}
                                    className={routeClass}
                                >
                                    {label}
                                </Link>
                            </li>
                        );
                    })}
                </ul>
                <EventDetailsContext.Consumer>
                    {value => {
                        return (
                            value.eventDetails && eventId &&
                            <NavigationBarClock
                                timeZone={value.eventDetails?.timeZone}
                            />
                        );
                    }}
                </EventDetailsContext.Consumer>
            </nav>
        </div>
    );
});

export default NavigationBar;
